import { Alert } from "antd";
import { I18N_NS } from "Config/i18n";
import _ from "lodash";
import { observer } from "mobx-react";
import { loginSettingsData } from "Pages/Login/Stores/LoginSettingsStore";
import { withTranslation, WithTranslation } from "react-i18next";

interface AdditionalPasswordRequirementsProps extends WithTranslation {
  errorMessage: string;
}

export const AdditionalPasswordRequirements = withTranslation(I18N_NS.LOGIN)(
  observer((props: AdditionalPasswordRequirementsProps) => {
    const { t, errorMessage } = props;
    const { passwordPolicy } = loginSettingsData;

    const additionalRequirements = () => {
      // const activeRequirements = [];
      const requirementsMap = {
        trivialPasswordsAllowed: () => t("The password can not be trivial (such as start123, admin)."),
        accountInformationAllowed: () =>
          t("The password should not contain account information (user id, name, company, name, mail address)."),
        pwnedPasswordsAllowed: () => (
          <>
            {t("The password you enter will be checked  and denied if it has been pwned using")}
            <span>
              :{" "}
              <a target="_blank" rel="noopener noreferrer" href="https://haveibeenpwned.com/">
                https://haveibeenpwned.com/
              </a>
            </span>
          </>
        ),
        checkedLastPasswords: (amount?: number) =>
          t("You should not reuse one of the last {{checkedLastPasswords}} passwords including the initial password.", {
            checkedLastPasswords: amount,
          }),
      };

      /**
       * TODO: any better implementation?
       */
      // for (const key in passwordPolicy) {
      //   if (Object.prototype.hasOwnProperty.call(requirementsMap, key)) {
      //     if (typeof passwordPolicy[key] === "boolean" && !passwordPolicy[key]) {
      //       activeRequirements.push(requirementsMap[key](passwordPolicy[key]));
      //     }
      //     if (typeof passwordPolicy[key] === "number" && passwordPolicy[key] > 0) {
      //       activeRequirements.push(requirementsMap[key](passwordPolicy[key]));
      //     }
      //   }
      // }

      const activeRequirements = Object.entries(passwordPolicy || {})
        .filter(([key]) => requirementsMap && key in requirementsMap)
        .reduce((a, [key, value]) => {
          if (value === false || (_.isNumber(value) && value > 0)) a.push(requirementsMap[key](value));
          return a;
        }, []);

      return (
        <ul>
          {activeRequirements.map((rule, idx) => (
            <li key={idx}>{rule}</li>
          ))}
        </ul>
      );
    };
    return (
      <Alert
        type={errorMessage ? "error" : "warning"}
        style={{ padding: 8, marginBottom: 24 }}
        title={
          <div style={{ fontSize: "0.8rem" }}>
            <p style={{ fontWeight: "bold", fontSize: "0.9rem" }}>{t(errorMessage)}</p>
            <p>{t("Additionally")}:</p>
            {additionalRequirements()}
          </div>
        }
      />
    );
  })
);
